const merchant = {
  getlist: 'merchant/getlist-by-admin',
  get: 'merchant/get-by-admin',
  add: 'merchant/add-by-admin',
  update: 'merchant/update-by-admin',
  accept: 'merchant/accept',
  reject: 'merchant/reject',
  setverified: 'merchant/set-verified',
  remove: 'merchant/remove',
}
export default merchant
